import { DATE_FORMATS, SESSION_STORAGE_KEYS } from 'common/constants/SharedConstants';
import { getToastNotification } from 'common/sharedTemplates/toasterTemplates';
import {
  formatPhoneNumber,
  getAndCheck,
  getDate,
  getFilteredItems,
  getHelpDataContent,
  getTime,
  isValidObject,
  isValidValue,
  getValueOrEmptyStringWithComma,
  isMobileDevice,
  isDeliveryDisposition,
  getToday,
} from 'common/utilities/utils';
import {
  PAYMENT_TENDER_TYPES,
  CUSTOMER_NAME,
  DAT_DATE_TIME_MONTH,
  ONLY_TIME,  
} from '../constants/SharedConstants';
import {
  formatDateTime,
  getFormatFromUnix,
  getFormattedFromUnixWithTimeZone,
  getUnixTimeInSeconds,
} from './dayJsUtils';

import {
  getOrderStatusChangedAt,
  getOrderStatusValue,
  isCheckRetryCountForGetOrderTrackingStatus,
  isCheckSameOrderStatusMaintainLast30Mins,
  isCheckedInOrder,
  isCheckedInCheckedInRemake,
  isCheckedInCheckedInNotCollected,
  isCheckedInCooking,
  isSentPosCompletedOrder,
  isDasherEnrouteToPickup,
  isDasherEnrouteToDropOff,
  isDeliveryOrderPOSCompleted,
  isAddHopePurchase,
  isUndelivered,
  isUnassigned,
  isDeliveryOrderPickedUpOrOutForOrArrived,
  isCheckedInPrepared,
  isDeliveryOrderDelivered,
  orderStatusListOfFn,
  isCheckedInClosedOrder,
  isSentToPosCompletedOrisReadyPosInjection,
  isGiftCardPurchase,
  isAddHopeOrGiftCardPurchase,
} from './orderStatusUtils';
import isEmpty from 'lodash/isEmpty';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { updateOrderDetailsAnalytics } from 'common/utilities/orderProcessingSummaryUtils';
import { checkIsDriverArrived } from 'organisms/orderSummaryViews/presentation/sharedTemplates/orderSummaryDeliveryViewTemplates';

export const orderDetailsDefaultValue = {
  //Tenant Reducer
  tenantId: null,
  currencyCode: null,
  currencySymbol: null,
  currencyShortName: null,
  addHope: null,
  carryBag: null,
  currencyConversionFactor: null,
  pastOrderDateformat: '',
  pastOrderTimeFormat: '',
  storeSearch: null,
  driveTime: null,
  buffertimepmpickup: null,
  buffertimepmdelivery: null,
  favouriteOrderRegex:'',
  hideCancelOrderPanel: null,
  enableCancelOrderCallsupportModal: null,
  hidePickupCheckin: null,

  // UserOrderContext - userOrderState
  operatingTime: null,

  // appStateReducer
  userStatus: null,

  // helpReducer
  helpContantData: null,

  // storesReducer
  allStoresDetails: null,
  currentStoresDetails: {},
  operatingTimeFromStoreReducer: '',
  pickupOrderAvailableCollectionPoints: [],

  // profileReducer
  savedAddresses: null,

  // paymentsContentReducer
  paymentType: null,

  // postOrderReducer / orderReducer
  additionalChargeLines: null,
  customer: null,
  customerId: null,
  deliveryAddress: null,
  deliveryDetails: null,
  deliveryPartner: null,
  foodLines: null,
  orderId: null,
  displayOrderId: null,
  fulfillmentDateTime: null,
  orderDateOn: null,
  orderTime: null,
  displayOrderTime: null,
  displayFormatOrderTime: null,
  displayTodayDate: null,
  posOrderId: null,
  miscPaymentReferenceId: null,
  wiCodePurchaseId: null,
  userEmail: null,
  userPhone: null,
  service: null,
  status: null,
  orderStatus: null,
  orderStatusChangedAt: null,
  sameOrderStatusMaintainLast30Mins: null,
  store: null,
  storeName: null,
  phoneNumber: '',
  phoneNumberFormat: null,
  storeTimeZoneIANA: null,
  isContactless: false,
  filteredFoodLines: null,
  orderedItemDetails: null,
  orderingDateTime: null,
  orderingDate: '',
  orderingTime: '',
  fullAddressDetails: '',
  instruction: '',
  addressLines: '',
  taxLines: [],
  additionalCharges: [],
  subTotal: 0,
  discountTotal: 0,
  total: null,
  inclusiveTaxTotal: '',
  tenders: null,
  paymentReferences: null,
  taxTotal: null,
  orderAcceptedLoading: false,
  requestedTimeStamp: null,
  requestedDateTime: null,
  orderDateTimeInEpoch: null,
  oldOrderId: null,
  postOrderDetails: {},
  deliveryOrEstimatedOrCollectAtTime: null,
  pickupOrderEstimatedOrCollectAtTime: null,
  storeOperatingTime: null,

  // For Summary page
  isExternalTrackOrder: false,
  dispatch: null,
  isMobileView: isMobileDevice(window.innerWidth),
  discountLines: [],
  paymentDiscountLines: [],
  paymentDiscountTotal: 0,
  dispatchDeliveryOrderTrackerTimer: null,
  dispatchGetOrderStatusTimer: null,
  displayOrderProcessingPage: true,
  displayDeliveryOrderTrackerPage: false,
  retryCountForGetOrderStatus: 0,
  retryCountForGetOrderTrackingStatus: 0,
  isAnalyticsUpdated: false,
  isDeliveryOrderSentPOSCompleted: false,
  orderSummaryInfoDetailsShowInAccordion: false,
  orderSummaryInfoDetailsOpenAccordion: false,
  isOpenOrderSummaryDirectionMap: false,
  isOpenOrderSummarySaveYourOrderCheckoutFaster: false,
  isOpenSaveDeliveryAddressModal: false,
  savedAddressSucess: false,
  saveFavoriteSummarySucess: false,
  orderSummarySaveYourOrderCompleted: false,
  orderSummarySaveOrderDetails: {
    value: '',
    errorMessage: '',
    error: false,
  },
  isBasketsCreated: false,
  isGetStoreStatus: false,
  isShowPickupOrderCancelModal: false,
  pickupCancelOrder: false,
  isShowPickupOrderCheckReadyToPrepareModal: false,
  isPickupOrderUserConfirmedToCheckIn: false,
  isShowPickupOrderStoreClosedModal: false,
  isShowPickupOrderAlreadyCheckInModal: false,
  selectedPickupOrderCollectionMethod: null,

  showStoreDirectinPanelInOrderSummaryInfoDetails: false,
  showStoreHoursPanelInOrderSummaryInfoDetails: false,

  item: [],
  addHopeDataExistsId: '',
  carryBagDataExistsId: '',
  addHopeDataPrice: '',
  carryBagDataPrice: '',
  pickupClosedInfoModal: false,
  pickupClosingSoonModal: false,
  showCombinedDiscount: true,
  orderSummarycontentData: {},
  openCallSupportModal: false,
  showGiftCardOrVoucherSummary: false,
  showPromosSummary:false, 
  showOrderStatus: true,
};

/*********************************************************************
 * getDisplayOrderId
 * orderDetails
 *********************************************************************/
export const getDisplayOrderId = orderDetails => {
  if (orderDetails?.enableGlobalOrderTracking) {
    return parseInt(orderDetails?.referenceNumber) === 0 ? '' : orderDetails?.referenceNumber;
  }
  return parseInt(orderDetails?.posOrderId) === 0 ? '' : orderDetails?.posOrderId;
};

/*********************************************************************
 * getPaymentTypeFromContant
 * items, tenders
 *********************************************************************/

const getPaymentTypeFromContant = (items, tenders, paymentReferences = []) => {
  return getAndCheck(items?.length, tenders?.length)
    ? items?.find(item =>
        paymentReferences?.length > 0 &&
        PAYMENT_TENDER_TYPES?.CREDIT_CARD?.toLowerCase() === tenders?.[0]?.type?.toLowerCase()
          ? item?.fields?.title?.toLowerCase() === paymentReferences?.[0]?.paymentInstrumentType?.toLowerCase() ||
            item?.fields?.orderServName?.toLowerCase() === paymentReferences?.[0]?.paymentInstrumentType?.toLowerCase()
          : item?.fields?.title?.toLowerCase() === tenders?.[0]?.type?.toLowerCase() ||
            item?.fields?.orderServName?.toLowerCase() === tenders?.[0]?.type?.toLowerCase(),
      )
    : {};
};

/*********************************************************************
 * isPostOrPastOrderDetailsAvailable
 * { orderReducer, postOrderReducer }
 *********************************************************************/
export const isPostOrPastOrderDetailsAvailable = ({ orderReducer, postOrderReducer }) =>
  isPostOrderDetailsAvailable(postOrderReducer) || isPastOrderDetailsAvailable(orderReducer);

/*********************************************************************
 * isPostOrderDetailsAvailable
 * postOrderReducer
 *********************************************************************/
const isPostOrderDetailsAvailable = postOrderReducer =>
  postOrderReducer?.orderAccepted &&
  Object?.keys(postOrderReducer?.orderAccepted)?.length > 0 &&
  isValidValue(postOrderReducer?.orderAccepted?.id);

/*********************************************************************
 * isPastOrderDetailsAvailable
 * orderReducer
 *********************************************************************/
const isPastOrderDetailsAvailable = orderReducer =>
  orderReducer?.pastOrderResponse?.length > 0 && orderReducer?.pastOrderResponse?.[0]?.id;

/*********************************************************************
 * isCreateOrderDetailsAvailable
 * orderReducer
 *********************************************************************/
const isCreateOrderDetailsAvailable = orderReducer =>
  orderReducer?.response?.order &&
  Object?.keys(orderReducer?.response?.order)?.length &&
  orderReducer?.response?.order?.id;

/*********************************************************************
 * getOrderReducerPastOrderResponse
 * orderReducer
 *********************************************************************/
const getOrderReducerPastOrderResponse = orderReducer =>
  isPastOrderDetailsAvailable(orderReducer) ? orderReducer?.pastOrderResponse?.[0] : null;

/*********************************************************************
 * getOrderReducerCreateOrderResponse
 * orderReducer
 *********************************************************************/
const getOrderReducerCreateOrderResponse = orderReducer =>
  isCreateOrderDetailsAvailable(orderReducer) ? orderReducer?.response?.order : null;

/*********************************************************************
 * getPostOrderReducerOrderAccepted
 * postOrderReducer
 *********************************************************************/
const getPostOrderReducerOrderAccepted = postOrderReducer =>
  isPostOrderDetailsAvailable(postOrderReducer) ? postOrderReducer?.orderAccepted : null;

/*********************************************************************
 * getOrderDetailsFromReducer
 * Get order details from PostOrder response or PastOrder response
 * params
 * console.debug('getOrderDetailsFromReducer => ');
 *********************************************************************/
export const getOrderDetailsFromReducer = params => {
  const { postOrderReducer = {}, orderReducer = {}, orderDetails = {}, isCheckOrderDetails = true } = params;

  let returnOrderDetails = getPostOrderReducerOrderAccepted(postOrderReducer);

  if (returnOrderDetails === null) {
    returnOrderDetails = getOrderReducerPastOrderResponse(orderReducer);

    if (returnOrderDetails === null) {
      returnOrderDetails = getOrderReducerCreateOrderResponse(orderReducer);

      if (isCheckOrderDetails && returnOrderDetails === null) {
        returnOrderDetails =
          orderDetails?.postOrderDetails && Object.keys(orderDetails?.postOrderDetails)?.length
            ? orderDetails?.postOrderDetails
            : {};
      }
    }
  }

  return returnOrderDetails || {};
};

/*********************************************************************
 * updateOrderDetailsFromTenantReducer
 * params
 * console.debug('updateOrderDetailsFromTenantReducer => ');
 *********************************************************************/
export const updateOrderDetailsFromTenantReducer = params => {
  const {
    props,
    dispatch,
    tenantReducer = {},
    isExternalTrackOrder = false,
    dispositionPaymentPage,
    updateSetOrderDetails,
  } = params;
  const {
    tenantId,
    currencyCode,
    currencySymbol,
    currencyShortName,
    addHope,
    carryBag,
    currencyConversionFactor,
    pastOrderDateformat,
    pastOrderTimeFormat,
    storeSearch = {},
    driveTime,
    buffertimepmpickup,
    buffertimepmdelivery,
    favouriteOrderRegex,
    componentOptions,
    enablePickupMethodChangePostOrder,
  } = tenantReducer;

  updateSetOrderDetails({
    props,
    dispatch,
    tenantId,
    enablePickupMethodChangePostOrder,
    currencyCode,
    currencySymbol,
    currencyShortName,
    addHope,
    carryBag,
    currencyConversionFactor,
    pastOrderDateformat,
    pastOrderTimeFormat,
    isExternalTrackOrder,
    storeSearch,
    driveTime,
    buffertimepmpickup,
    buffertimepmdelivery,
    favouriteOrderRegex,
    operatingTime: dispositionPaymentPage?.store?.summary?.timings,
    hideCancelOrderPanel: componentOptions?.web?.orderPages?.hideCancelOrderPanel,
    hidePickupCheckin: componentOptions?.web?.orderPages?.orderSummaryShowPickupOrderCollectionMethodPanel,
    showTaxLines: componentOptions?.web?.cartPage?.showTaxLines,
    showTaxExcluded: componentOptions?.web?.checkout?.showTaxExcluded,
    enableGlobalOrderTracking: componentOptions?.web?.orderPages?.enableGlobalOrderTracking,
    enableRetryCountForPickupOrderTracking: componentOptions?.web?.orderPages?.enableRetryCountForPickupOrderTracking,
    enableCancelOrderCallsupportModal: componentOptions?.web?.orderPages?.enableCancelOrderCallsupportModal,
    showOrderTrackingIFrame: componentOptions?.web?.orderPages?.showOrderTrackingIFrame,
    orderTrackingProgressBarCount: componentOptions?.web?.orderPages?.orderTrackingProgressBarCount,
    showDeliveryDriverDetails: componentOptions?.web?.orderPages?.showDeliveryDriverDetails,
    showDeliveryTrackingMap: componentOptions?.web?.orderPages?.showDeliveryTrackingMap,
    orderTrackingProgressBarScheduleOrdersCount:
      componentOptions?.web?.orderPages?.orderTrackingProgressBarScheduleOrdersCount,
    showOrderSummaryInfoDetails: componentOptions?.web?.orderPages?.showOrderSummaryInfoDetails,
    deliveryProgressBarAsapOrder: componentOptions?.web?.orderPages?.deliveryProgressBarAsapOrder,
    deliveryProgressBarScheduleOrders: componentOptions?.web?.orderPages?.deliveryProgressBarScheduleOrders,
    hideEstimatedDeliveryTime: componentOptions?.web?.orderPages?.hideEstimatedDeliveryTime,
    getDeliveryActualPickupTime: componentOptions?.web?.orderPages?.getDeliveryActualPickupTime,
    hideProgressBar: componentOptions?.web?.orderPages?.hideProgressBar,
    enableScheduleOrder: componentOptions?.web?.dispositionConfig?.enableScheduleOrder,
    enableClickCollectScheduleOrder: componentOptions?.web?.dispositionConfig?.enableClickCollectScheduleOrder,
    allowScheduleOrderForDispositions: componentOptions?.web?.scheduledDelivery?.allowScheduleOrderForDispositions,
    showGiftCardOrVoucherSummary: tenantReducer?.componentOptions?.web?.orderPages?.showGiftCardOrVoucherSummary,
    showPromosSummary: tenantReducer?.componentOptions?.web?.orderPages?.showPromosSummary,
  });
};

export const updateOrderDetailsFromHelpReducer = params => {
  const { helpReducer, updateSetOrderDetails } = params;

  updateSetOrderDetails({
    helpContantData: getHelpDataContent(helpReducer?.helpResponse || null),
  });
};
/*********************************************************************
 * updateOrderDetailsFromAppStateReducer
 * params
 * console.debug('updateOrderDetailsFromAppStateReducer => ');
 *********************************************************************/
export const updateOrderDetailsFromAppStateReducer = params => {
  const { appStateReducer, updateSetOrderDetails } = params;

  updateSetOrderDetails({
    userStatus: appStateReducer?.userStatus,
  });
};

/*********************************************************************
 * updateOrderDetailsFromProfileReducer
 * params
 * console.debug('updateOrderDetailsFromProfileReducer => ');
 *********************************************************************/
export const updateOrderDetailsFromProfileReducer = params => {
  const { profileReducer, orderDetails, updateSetOrderDetails } = params;

  updateSetOrderDetails({
    favouriteOrders: profileReducer?.favouriteOrders,
    savedAddresses: profileReducer?.savedAddresses,
    orderSummarySaveYourOrderCompleted: isOrderSummarySaveYourOrderCompletedCheck(
      orderDetails,
      profileReducer?.favouriteOrders,
    ),
  });
};

/*********************************************************************
 * isOrderSummarySaveYourOrderCompletedCheck
 * params
 * console.debug('isOrderSummarySaveYourOrderCompletedCheck => ');
 *********************************************************************/
export const isOrderSummarySaveYourOrderCompletedCheck = (orderDetails, favouriteOrders = null) => {
  const favOrderList = favouriteOrders ? favouriteOrders : orderDetails?.favouriteOrders;
  return (
    orderDetails?.userStatus?.loggedIn &&
    favOrderList?.findIndex(element => element?.id === orderDetails?.orderId) !== -1
  );
};

/*********************************************************************
 * updateOrderDetailsFromStoreReducer
 * params
 * console.debug('updateOrderDetailsFromStoreReducer => ', storesReducer);
 *********************************************************************/
export const updateOrderDetailsFromStoreReducer = params => {
  const { storesReducer = {}, updateSetOrderDetails } = params;
  const currentStoresDetails = storesReducer?.storesWithStatus?.length ? storesReducer?.storesWithStatus?.[0] : {};
  updateSetOrderDetails({
    allStoresDetails: storesReducer?.allStores?.length ? storesReducer?.allStores : [],
    currentStoresDetails,
    operatingTimeFromStoreReducer: Object.keys(currentStoresDetails)?.length
      ? currentStoresDetails?.summary?.timings?.operatingHours
      : '',
    pickupOrderAvailableCollectionPoints: Object.keys(currentStoresDetails)?.length
      ? currentStoresDetails?.summary?.availableCollectionPoints
      : null,
  });
};

/*********************************************************************
 * updateOrderDetailsFromCreateOrderReducer
 * params
 * console.debug('updateOrderDetailsFromCreateOrderReducer => ');
 *********************************************************************/
export const updateOrderDetailsFromCreateOrderReducer = params => {
  const { orderReducer = {}, paymentsContentReducer = {}, orderDetails, updateSetOrderDetails } = params;
  const orderReducerCreateOrderResponse = orderReducer?.response?.order;
  updateSetOrderDetails({
    ...getUpdatedOrderDetails({
      orderReducerCreateOrderResponse,
      paymentsContentReducer,
      orderDetails,
    }),
  });
};

/*********************************************************************
 * updateOrderDetailsFromReducers
 * params
 * console.debug('updateOrderDetailsFromReducers => ', getOrderStatusValue(postOrPastOrderDetails) + ' ' + orderStatus);
 *********************************************************************/
export const updateOrderDetailsFromReducers = params => {
  const {
    postOrderReducer = {},
    orderReducer = {},
    paymentsContentReducer = {},
    isCheckOrderDetails = true,
    orderDetails,
    updateSetOrderDetails,
  } = params;
  const postOrPastOrderDetails = getOrderDetailsFromReducer({ postOrderReducer, orderReducer, isCheckOrderDetails });
  const { orderStatus, retryCountForGetOrderTrackingStatus, tenders, paymentReferences, displayOrderId } = orderDetails;
  if (
    getOrderStatusValue({ ...orderDetails, ...postOrPastOrderDetails }) !== orderStatus ||
    getDisplayOrderId({ ...orderDetails, ...postOrPastOrderDetails }) !== displayOrderId
  ) {
    updateSetOrderDetails({
      ...getUpdatedOrderDetails({ postOrPastOrderDetails, paymentsContentReducer, orderDetails }),
    });
  } else if (isCheckRetryCountForGetOrderTrackingStatus(orderDetails, postOrPastOrderDetails)) {
    updateSetOrderDetails({
      deliveryPartner: postOrPastOrderDetails?.deliveryPartner,
      deliveryDetails: postOrPastOrderDetails?.deliveryDetails,
      retryCountForGetOrderTrackingStatus: retryCountForGetOrderTrackingStatus + 1,
      fullAddressDetails: getFullAddressDetails(postOrPastOrderDetails?.deliveryAddress),
    });
  }
  if (tenders !== postOrPastOrderDetails?.tenders || paymentReferences !== postOrPastOrderDetails?.paymentReferences) {
    updateSetOrderDetails({
      tenders: postOrPastOrderDetails?.tenders,
      paymentReferences: postOrPastOrderDetails?.paymentReferences,
      paymentType: getPaymentTypeFromContant(
        paymentsContentReducer?.tendersContent?.items,
        postOrPastOrderDetails?.tenders,
        postOrPastOrderDetails?.paymentReferences,
      ),
    });
  }
};

/*********************************************************************
 * updatOrderDetailsForAddHopeOrGiftCardPurchase
 * params
 * console.debug('updatOrderDetailsForAddHopeOrGiftCardPurchase => ');
 *********************************************************************/
export const updatOrderDetailsForAddHopeOrGiftCardPurchase = params => {
  const { postOrderReducer, orderDetails, updateSetOrderDetails } = params;
  if (!postOrderReducer?.addHopeOrderLoading && isAddHopePurchase()) {
    const { miscPaymentReferenceId, status } = postOrderReducer?.addHopeOrderResponse;
    const addHopeDetails = { status, orderStatus: status };
    if (orderDetails?.miscPaymentReferenceId !== miscPaymentReferenceId) {
      addHopeDetails.miscPaymentReferenceId = miscPaymentReferenceId;
    }
    updateSetOrderDetails(addHopeDetails);
  }
  if (!postOrderReducer?.giftCardPurchaseLoading && isGiftCardPurchase()) {
    const { miscPaymentReferenceId, status } = postOrderReducer?.giftCardPurchaseResponse;
    const giftCardDetails = { status, orderStatus: status };
    if (orderDetails?.wiCodePurchaseId !== miscPaymentReferenceId) {
      giftCardDetails.wiCodePurchaseId = miscPaymentReferenceId;
    }
    updateSetOrderDetails(giftCardDetails);
  }
};

/*********************************************************************
 * getUpdatedOrderDetails
 * params
 * console.debug('getUpdatedOrderDetails => ');
 *********************************************************************/
export const getUpdatedOrderDetails = params => {
  const {
    postOrPastOrderDetails = {},
    orderReducerCreateOrderResponse = {},
    paymentsContentReducer = {},
    orderDetails,
  } = params;

  const orderDetailsFromReducer = isValidObject(postOrPastOrderDetails)
    ? postOrPastOrderDetails
    : orderReducerCreateOrderResponse;

  const returnOrderDetails = getUpdatedOrderDetailsFromReducer({ orderDetailsFromReducer, orderDetails });
  returnOrderDetails.postOrderDetails = postOrPastOrderDetails;
  returnOrderDetails.paymentType = getPaymentTypeFromContant(
    paymentsContentReducer?.tendersContent?.items,
    orderDetailsFromReducer?.tenders,
    orderDetailsFromReducer?.paymentReferences,
  );

  return returnOrderDetails;
};

/*********************************************************************
 * getDeliveryOrCollectedDateTime
 * params -  { storeTimeZoneIANA, estimatedDeliveryTime, orderTime,format }
 * console.debug('getDeliveryOrCollectedTime => ');
 *********************************************************************/
const getDeliveryOrCollectedDateTime = params => {
  const { storeTimeZoneIANA, estimatedDeliveryTime, orderTime, format = DATE_FORMATS?.H_MM_A } = params;
  return storeTimeZoneIANA
    ? getFormattedFromUnixWithTimeZone(estimatedDeliveryTime || orderTime, storeTimeZoneIANA, format)
    : getFormatFromUnix(estimatedDeliveryTime || orderTime, format);
};

/*********************************************************************
 * getOrderPlacedDateOn
 * params - { storeTimeZoneIANA, fulfillmentDateTime, pastOrderDateformat }
 * console.debug('getOrderPlacedDateOn => ');
 *********************************************************************/
const getOrderPlacedDateOn = params => {
  const { storeTimeZoneIANA, statusUpdatedDate, pastOrderDateformat } = params;
  return storeTimeZoneIANA
    ? getFormattedFromUnixWithTimeZone(statusUpdatedDate, storeTimeZoneIANA, pastOrderDateformat)
    : getFormatFromUnix(statusUpdatedDate, pastOrderDateformat);
};

/*********************************************************************
 * getUpdatedOrderDetailsFromReducer
 * params
 * console.debug('getUpdatedOrderDetailsFromReducer => ');
 *********************************************************************/
export const getUpdatedOrderDetailsFromReducer = params => {
  const { orderDetailsFromReducer, orderDetails = {} } = params;
  const returnOrderDetails = {
    additionalChargeLines: orderDetailsFromReducer?.additionalChargeLines,
    customerId: orderDetailsFromReducer?.customer?.id,
    customer: orderDetailsFromReducer?.customer,
    deliveryAddress: orderDetailsFromReducer?.deliveryAddress,
    deliveryDetails: orderDetailsFromReducer?.deliveryDetails,
    deliveryPartner: orderDetailsFromReducer?.deliveryPartner,

    foodLines: orderDetailsFromReducer?.foodLines,
    orderId: orderDetailsFromReducer?.id,
    displayOrderId: getDisplayOrderId({ ...orderDetails, ...orderDetailsFromReducer }),
    fulfillmentDateTime: orderDetailsFromReducer?.fulfillmentDateTime,
    fulfillmentDateTimeFormatted: getFormattedFromUnixWithTimeZone(
      orderDetailsFromReducer?.fulfillmentDateTime,
      orderDetailsFromReducer?.store?.timeZoneIANA,
    ),

    orderTime: getUnixTimeInSeconds(orderDetailsFromReducer?.fulfillmentDateTime),
    displayOrderTime: getTime(orderDetailsFromReducer?.fulfillmentDateTime),
    displayFormatOrderTime: formatDateTime(
      getUnixTimeInSeconds(orderDetailsFromReducer?.fulfillmentDateTime),
      orderDetails?.pastOrderTimeFormat,
    ),
    displayTodayDate: formatDateTime(new Date(), orderDetails?.pastOrderDateformat),
    posOrderId: orderDetailsFromReducer?.posOrderId,

    userEmail: orderDetailsFromReducer?.customer?.email,
    userPhone: orderDetailsFromReducer?.customer?.phoneNumber || orderDetailsFromReducer?.customer?.phone,

    service: orderDetailsFromReducer?.service,
    status: orderDetailsFromReducer?.status,
    orderStatus: getOrderStatusValue({ ...orderDetails, ...orderDetailsFromReducer }),
    orderStatusChangedAt: getOrderStatusChangedAt({ orderDetails, orderDetailsFromReducer }),
    sameOrderStatusMaintainLast30Mins: isCheckSameOrderStatusMaintainLast30Mins({
      orderDetails,
      orderDetailsFromReducer,
    }),

    store: orderDetailsFromReducer?.store,
    storeName: orderDetailsFromReducer?.store?.name,
    phoneNumber: orderDetailsFromReducer?.store?.phoneNumber,
    phoneNumberFormat: formatPhoneNumber(orderDetailsFromReducer?.store?.phoneNumber),
    storeTimeZoneIANA: orderDetailsFromReducer?.store?.timeZoneIANA,
    storeOperatingTime: orderDetailsFromReducer?.store?.timings,

    deliveryOrEstimatedOrCollectAtMonthDate: getDeliveryOrCollectedDateTime({
      estimatedDeliveryTime: orderDetailsFromReducer?.deliveryDetails?.estimatedDeliveryTime,
      orderTime: orderDetailsFromReducer?.fulfillmentDateTime,
      storeTimeZoneIANA: orderDetailsFromReducer?.store?.timeZoneIANA,
      format: DATE_FORMATS.MMMM_D,
    }),
    deliveryOrEstimatedOrCollectAtTime: getDeliveryOrCollectedDateTime({
      estimatedDeliveryTime: orderDetailsFromReducer?.deliveryDetails?.estimatedDeliveryTime,
      orderTime: orderDetailsFromReducer?.fulfillmentDateTime,
      storeTimeZoneIANA: orderDetailsFromReducer?.store?.timeZoneIANA,
    }),
    deliveryOrActualOrCollectAtTime: getDeliveryOrCollectedDateTime({
      estimatedDeliveryTime: orderDetailsFromReducer?.deliveryDetails?.actualDeliveryTime,
      orderTime: orderDetailsFromReducer?.fulfillmentDateTime,
      storeTimeZoneIANA: orderDetailsFromReducer?.store?.timeZoneIANA,
    }),
    pickupOrderEstimatedOrCollectAtTime: getDeliveryOrCollectedDateTime({
      estimatedDeliveryTime: orderDetailsFromReducer?.deliveryDetails?.actualPickupTime,
      orderTime: orderDetailsFromReducer?.fulfillmentDateTime,
      storeTimeZoneIANA: orderDetailsFromReducer?.store?.timeZoneIANA,
    }),
    orderDateOn: getOrderPlacedDateOn({
      statusUpdatedDate: orderDetailsFromReducer?.statusUpdatedDate,
      storeTimeZoneIANA: orderDetailsFromReducer?.store?.timeZoneIANA,
      pastOrderDateformat: orderDetails?.pastOrderDateformat,
    }),
    statusUpdatedDate: orderDetailsFromReducer?.statusUpdatedDate,
    isContactless: orderDetailsFromReducer?.isContactless,
    filteredFoodLines: getFilteredItems(
      orderDetailsFromReducer?.foodLines,
      orderDetails?.addHope,
      orderDetails?.carryBag,
    ),
    orderedItemDetails: orderDetailsFromReducer?.orderedItemDetails,
    orderingDateTime: orderDetailsFromReducer?.orderingDateTime,
    orderingDateTimeFormatted: getFormattedFromUnixWithTimeZone(
      orderDetailsFromReducer?.orderingDateTime,
      orderDetailsFromReducer?.store?.timeZoneIANA,
    ),
    orderingDate: getDate(orderDetailsFromReducer?.orderingDateTime),
    orderingTime: getTime(orderDetailsFromReducer?.orderingDateTime),
    fullAddressDetails: getFullAddressDetails(orderDetailsFromReducer?.deliveryAddress),
    instruction: orderDetailsFromReducer?.instruction,
    addressLines: orderDetailsFromReducer?.store?.address?.addressLines,
    taxLines: orderDetailsFromReducer?.taxLines,
    additionalCharges: orderDetailsFromReducer?.additionalChargeLines,

    subTotal: orderDetailsFromReducer?.subTotal,
    discountLines: orderDetailsFromReducer?.discountLines,
    paymentDiscountLines: orderDetailsFromReducer?.paymentDiscountLines || [],
    paymentDiscountTotal: orderDetailsFromReducer?.paymentDiscountTotal || 0,
    discountTotal: orderDetailsFromReducer?.discountTotal,
    total: orderDetailsFromReducer?.total || orderDetailsFromReducer?.amount,
    inclusiveTaxTotal: orderDetailsFromReducer?.inclusiveTaxTotal,

    tenders: orderDetailsFromReducer?.tenders,
    paymentReferences: orderDetailsFromReducer?.paymentReferences,
    taxTotal: orderDetailsFromReducer?.taxTotal,

    orderAcceptedLoading: orderDetailsFromReducer?.orderAcceptedLoading || false,

    requestedTimeStamp: orderDetailsFromReducer?.requestedTimeStamp,
    requestedDateTime: orderDetailsFromReducer?.requestedDateTime,
    orderDateTimeInEpoch: orderDetailsFromReducer?.orderDateTimeInEpoch,
    isOrderSavedAsFavorite: false,
    favoriteOrderName: null,
    bottleDepositChargeTotal: orderDetailsFromReducer?.bottleDepositChargeTotal || 0,
    tipCharge: orderDetailsFromReducer?.driverTippingCharge,
    tipChargeType: orderDetailsFromReducer?.driverTippingChargeType,
    driverTippingChargeOption: orderDetailsFromReducer?.driverTippingChargeOption,
  };

  if (
    orderDetails?.orderId !== null &&
    orderDetailsFromReducer?.id !== null &&
    orderDetails?.orderId !== orderDetailsFromReducer?.id
  ) {
    returnOrderDetails.oldOrderId = orderDetailsFromReducer?.id;
  }

  return returnOrderDetails;
};

/**
 * Method to get full addresses of the store
 * @{addresses} - object - full addresses details
 */
export const getFullAddressDetails = addresses => {
  if (isValidObject(addresses)) {
    const { addressLines, city, state, country, pinCode } = addresses;
    const pinCodeTxt = getValueOrEmptyStringWithComma(pinCode);
    const cityTxt = getValueOrEmptyStringWithComma(city);
    const stateTxt = getValueOrEmptyStringWithComma(state);
    const countryTxt = getValueOrEmptyStringWithComma(country);

    const addressLine = addressLines?.filter(e => e).join(', ');
    return `${addressLine}${cityTxt}${stateTxt}${pinCodeTxt}${countryTxt}`;
  }
  return null;
};

export const prepareOrderSummaryContentData = (orderTrackingContentData, orderDetails, updateSetOrderDetails) => {
  !isEmpty(orderTrackingContentData) &&
    orderDetails?.enableRetryCountForPickupOrderTracking &&
    updateSetOrderDetails({
      orderSummarycontentData: formatOrderSummaryContentData(orderTrackingContentData.items?.[0]?.fields, orderDetails),
    });
};

export const getStatusMessageFromContentful = orderDetails => {
  const { orderSummarycontentData } = orderDetails;
  return orderSummarycontentData?.headline?.replace(
    CUSTOMER_NAME,
    orderDetails?.customer?.firstName.replace(/(.{7})..+/, '$1...'),
  );
};


export const getSubStatusMessageFromContentful = orderDetails => {
  const { orderSummarycontentData, enableClickCollectScheduleOrder, allowScheduleOrderForDispositions, service } =
    orderDetails;
  const enableClickCollectScheduleOrderFlag =
    enableClickCollectScheduleOrder && allowScheduleOrderForDispositions?.includes(service);
  if (isCheckedInPrepared(orderDetails) || isDasherEnrouteToDropOff(orderDetails)) {
    return orderDetails?.paymentReferences[0]?.paymentType === PAYMENT_TENDER_TYPES?.PAY_BY_CASH &&
      orderSummarycontentData?.payOnArrival
      ? checkIsDriverArrived(orderDetails)
      : orderSummarycontentData?.subHeadline;
  } else {
    return orderSummarycontentData?.scheduleOrders || enableClickCollectScheduleOrderFlag
      ? replaceTimeForScheduleOrders(orderSummarycontentData, orderDetails)
      : orderSummarycontentData?.subHeadline;
  }
};

export const toastMsgDispositionCheck = orderDetails => {
  return isDeliveryDisposition(orderDetails?.service)
    ? isUndelivered(orderDetails) || isUnassigned(orderDetails)
    : isCheckedInCheckedInRemake(orderDetails) || isCheckedInCheckedInNotCollected(orderDetails);
};

export const getToastMsgForRemake = orderDetails => {
  toastMsgDispositionCheck(orderDetails) &&
    getToastNotification(translateWithI18Next(TRANSLATE_MAPPING_KEY?.ORDER_UPDATE_TEXT), 4000);
};

export const replaceTimeForScheduleOrders = (orderSummarycontentData, orderDetails) => {
  const { enableClickCollectScheduleOrder, allowScheduleOrderForDispositions, service } = orderDetails;
  const enableClickCollectScheduleOrderFlag =
    enableClickCollectScheduleOrder && allowScheduleOrderForDispositions?.includes(service);
  const timeStamp = orderSummarycontentData?.subHeadline?.includes(DAT_DATE_TIME_MONTH);
  const requestedDateTime = orderDetails?.fulfillmentDateTime;
  const orderReadyDateTime = getFormattedFromUnixWithTimeZone(
    requestedDateTime,
    orderDetails?.store?.timeZoneIANA,
    timeStamp ? DATE_FORMATS?.DDDD_D_MMMM_A : DATE_FORMATS?.hh_mm_A,
  );
  const date = getFormattedFromUnixWithTimeZone(
    requestedDateTime,
    orderDetails?.store?.timeZoneIANA,
    DATE_FORMATS?.MMMM_D,
  );
  const dateTimeToday =
    enableClickCollectScheduleOrderFlag && timeStamp
      ? orderReadyDateTime.replace(/^\w+/, getToday(date, orderDetails?.store?.timeZoneIANA))
      : orderReadyDateTime;
  const dateTimeArray = dateTimeToday?.split(' ');
  const dateTime = timeStamp
    ? translateWithI18Next(dateTimeArray[0]) +
      ' ' +
      dateTimeArray[1] +
      ' ' +
      translateWithI18Next(dateTimeArray[2]) +
      ' ' +
      dateTimeArray[3] +
      ' ' +
      dateTimeArray[4] +
      ' ' +
      dateTimeArray[5]
    : orderReadyDateTime;
  const updatedSubHeadLine = orderSummarycontentData?.subHeadline?.replace(
    timeStamp ? DAT_DATE_TIME_MONTH : ONLY_TIME,
    `<span class="red">${dateTime}</span>`,
  );
  return updatedSubHeadLine ? `<div class='subheadline-content'>${updatedSubHeadLine}</div>` : '';
};

export const formatOrderSummaryContentData = (orderContent, orderDetails) => {
  const formatData = orderContent?.content?.find(contentData => {
    if (
      !orderDetails?.requestedDateTime?.isForNow &&
      (isSentToPosCompletedOrisReadyPosInjection(orderDetails) ||
        isCheckedInCooking(orderDetails) ||
        isDasherEnrouteToPickup(orderDetails) ||
        isDeliveryOrderPickedUpOrOutForOrArrived(orderDetails))
    ) {
      return (
        contentData?.fields?.scheduleOrders &&
        contentData?.fields.orderStatus.toLowerCase() === orderDetails?.orderStatus?.toLowerCase()
      );
    } else {
      return contentData?.fields.orderStatus.toLowerCase() === orderDetails?.orderStatus?.toLowerCase();
    }
  });
  return formatData?.fields;
};

export const getFilteredOrderStatusListOfFn = (params, orderDetails) =>
  Object?.keys?.(params)?.filter?.(item => orderStatusListOfFn?.()?.[item]?.(orderDetails));

export const getCardFillRange = orderDetails => {
  const ordertype =
    !orderDetails?.enableClickCollectScheduleOrder && orderDetails?.requestedDateTime?.isForNow
      ? orderDetails?.deliveryProgressBarAsapOrder
      : orderDetails?.deliveryProgressBarScheduleOrders;
  return ordertype?.[getFilteredOrderStatusListOfFn(ordertype, orderDetails)];
};

export const hideEstimatedArraival = orderDetails =>
  orderDetails?.hideEstimatedDeliveryTime?.[
    getFilteredOrderStatusListOfFn(orderDetails?.hideEstimatedDeliveryTime, orderDetails)
  ] ?? false;


export const hideProgessBar = orderDetails => {
  const progressBarHideCheck =
    orderDetails?.hideProgressBar?.[getFilteredOrderStatusListOfFn(orderDetails?.hideProgressBar, orderDetails)] ??
    false;
  return progressBarHideCheck && !orderDetails?.requestedDateTime?.isForNow;
}
  


export const checkCreateOrLoginAccount = ({
  orderDetails,
  orderReducer,
  postOrderReducer,
  paymentsContentReducer,
  updateSetOrderDetails,
  dispatch,
}) => {
  if (orderDetails?.tenantId) {
    const isCreateOrLoginKFCAccount = sessionStorage.getItem(SESSION_STORAGE_KEYS.ORDER_TRACKING_CLICK_KFC_ACCOUNT);
    if (!isCreateOrLoginKFCAccount && isPostOrPastOrderDetailsAvailable({ orderReducer, postOrderReducer })) {
      updateOrderDetailsFromReducers({
        postOrderReducer,
        orderReducer,
        paymentsContentReducer,
        isCheckOrderDetails: false,
        orderDetails,
        updateSetOrderDetails,
      });

      if (orderDetails?.tenantId) {
        updateOrderDetailsAnalytics({ dispatch, orderDetails, updateSetOrderDetails });
      }
    }
  }
  isAddHopeOrGiftCardPurchase() &&
    updatOrderDetailsForAddHopeOrGiftCardPurchase({ postOrderReducer, orderDetails, updateSetOrderDetails });
};

export const checkOrderSummaryModelOpen = orderDetails => {
  const { enableClickCollectScheduleOrder, allowScheduleOrderForDispositions, service } = orderDetails;
  const enableClickCollectScheduleOrderFlag =
    enableClickCollectScheduleOrder && allowScheduleOrderForDispositions?.includes(service);
  if (isDeliveryDisposition(service)) {
    if (
      isDeliveryOrderDelivered(orderDetails) ||
      isUndelivered(orderDetails) ||
      isDeliveryOrderPickedUpOrOutForOrArrived(orderDetails) ||
      isUnassigned(orderDetails)
    ) {
      return false;
    } else if (
      isDeliveryOrderPOSCompleted(orderDetails) ||
      isDasherEnrouteToPickup(orderDetails) ||
      isDasherEnrouteToDropOff(orderDetails)
    ) {
      return true;
    } else {
      return true;
    }
  } else {
    return enableClickCollectScheduleOrderFlag
      ? Boolean(
          isSentPosCompletedOrder(orderDetails) ||
            isCheckedInClosedOrder(orderDetails) ||
            isCheckedInOrder(orderDetails),
        )
      : isSentPosCompletedOrder(orderDetails);

  }
};

export const checkPaymentTextForRefund = orderDetails => {
  return orderDetails?.paymentReferences[0]?.paymentType !== PAYMENT_TENDER_TYPES?.PAY_BY_CASH
    ? getSubStatusMessageFromContentful(orderDetails)
    : '';
};

